export const WORKSPACE_ONBOARDING_TRIGGER_MESSAGE =
  "Hi, I'd like to set up this workspace.";

type WorkspaceMode = "agent" | "chat";

interface OnboardingHeaderOptions {
  needsOnboarding: boolean;
  workspaceMode: WorkspaceMode;
  onboardingAgentId: number | null;
  conversationId: number | string | null;
}

/** Keep workspace setup instructions on the setup conversation only. */
export function shouldSendWorkspaceOnboardingHeaders({
  needsOnboarding,
  workspaceMode,
  onboardingAgentId,
  conversationId,
}: OnboardingHeaderOptions): boolean {
  if (!needsOnboarding) return false;
  if (workspaceMode === "chat") return true;

  return (
    conversationId !== null &&
    conversationId !== undefined &&
    onboardingAgentId !== null &&
    Number(conversationId) === onboardingAgentId
  );
}

/** Temporarily mark the one request that creates setup chat. */
export function sendWithWorkspaceOnboardingHeaders<T>(
  headers: Record<string, string>,
  send: () => T,
): T {
  const previousMode = headers["X-Onboarding-Mode"];
  const previousName = headers["X-Workspace-Name"];
  headers["X-Onboarding-Mode"] = "true";
  delete headers["X-Workspace-Name"];
  try {
    return send();
  } finally {
    if (previousMode === undefined) delete headers["X-Onboarding-Mode"];
    else headers["X-Onboarding-Mode"] = previousMode;
    if (previousName === undefined) delete headers["X-Workspace-Name"];
    else headers["X-Workspace-Name"] = previousName;
  }
}
